import {
    AfterViewInit,
    Component,
    OnInit,
    Input,
    ViewEncapsulation,
    ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Helpers } from '../../../../../helpers';
import { PublisherDetailTab } from '../../owner/publisher-detail/publisher-detail.component';
import { Paths } from '../../../../../models/enums';
import { DataService } from '../../../../../_services/data.service';

@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    encapsulation: ViewEncapsulation.None
})
export class InventoryComponent implements OnInit {
    selectedSiteId: string;
    selectedSiteName: string;
    selectedPageId: string;
    selectedPageName: string;
    selectedPageIdQuery: string;
    hasPageQueryParam: boolean;
    @Input() publisherId: string;
    @Input() publisherName: string;
    @Input() routePath: string;

    ngAfterViewInit() { }
    constructor(router: Router, route: ActivatedRoute, dataService: DataService) {
        const path = Helpers.getPath();
        if (path == Paths.Owner) {
            var queryParams = route.snapshot.queryParams;
            var returnUrl = queryParams.returnUrl;
            if (returnUrl) {
                router.navigate([returnUrl], {
                    queryParams: {
                        returnUrl: undefined,
                        publisherId: undefined,
                        tab: PublisherDetailTab.Inventory
                    },
                    queryParamsHandling: 'merge'
                });
            }
        } else {
            var profile = dataService.getUser();
            this.publisherId = profile.publisherId;
        }
        if (!this.routePath) this.routePath = 'publisher/inventory';

        if (route.snapshot.queryParams.pageId) {
            this.hasPageQueryParam = true;
            this.selectedPageChange({ id: route.snapshot.queryParams.pageId });
        }
        if (route.snapshot.queryParams.siteId) {
            this.selectedSiteChange({ id: route.snapshot.queryParams.siteId });
        }
    }

    ngOnInit() { }

    selectedSiteChange(site) {
        if (site == null) return;
        if (!this.hasPageQueryParam) this.selectedPageId = null;
        this.selectedSiteId = site.id;
        this.selectedSiteName = site.name;
    }

    selectedPageChange(page) {
        if (page == null) return;
        this.selectedPageId = page.id;
        this.selectedPageName = page.name;
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/inventory.component.ts